import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { PostAdminV1StoresStoreIdExportsBody } from '@nucleus-commerce/api-client/admin';

import { exportsApi } from '../api/exports-api';

import { jobKeys } from './job-keys';

/** 202 with a queued job; 422 on `body.filters.to` lands on the form. */
export function useCreateExport(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: PostAdminV1StoresStoreIdExportsBody) => exportsApi.create(storeId, body),
    meta: { successMessage: 'importsExports:toasts.exportStarted', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: jobKeys.exports(storeId) }),
  });
}
